

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import ContactInfoView from './ContactInfoView';

// const ChildTable = ({ loan_ID }) => {
//   const [selectedLoan, setSelectedLoan] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const [filters, setFilters] = useState({
//     dateRate: '',
//     sortOrder: '',
//   });

//   const [data, setData] = useState([]);


//    const handleContactInfoView = loan => {
//      setSelectedLoan(loan);
//      setIsModalOpen(true);
//    };
//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//   };

//   // Fetch data from API
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           // `https://finwise-backend.vercel.app/account/approved-loan-list/${loan_ID}/`,
//           // `https://finwiseback.finwise.com.bd/account/approved-loan-list/${loan_ID}/`,
//           `http://127.0.0.1:8000/account/approved-loan-list/${loan_ID}/`,
//           {
//             headers: {
//               Cookie: 'sessionid=vonpwnmq5904ndb7w395ect6tmgzey2r',
//             },
//           }
//         );
//         setData(response.data); // Set the API data
//       } catch (error) {
//         console.error('Error fetching data:', error);
//       }
//     };

//     fetchData();
//   }, [loan_ID]);

//   // Handle the filter and sort
//   const handleFilterChange = e => {
//     const { name, value } = e.target;
//     setFilters({ ...filters, [name]: value });
//   };

//   // Apply filters and sorting
//   const filteredData = data
//     .sort((a, b) => {
//       if (filters.sortOrder === 'ascending') {
//         return parseFloat(a.rate) - parseFloat(b.rate);
//       } else if (filters.sortOrder === 'descending') {
//         return parseFloat(b.rate) - parseFloat(a.rate);
//       }
//       return 0;
//     })
//     .filter(item => {
//       if (filters.dateRate === 'rate') {
//         return parseFloat(item.rate) >= 0; // Adjust rate filter logic as needed
//       } else if (filters.dateRate === 'date') {
//         return item.created_at >= '2024-08-01'; // Adjust date filter logic as needed
//       }
//       return true;
//     });

//   return (
//     <tr>
//       <td colSpan="9">
//         <div className="w-full p-4 bg-white">
//           <div className="bg-AboutUsBg p-4 rounded-lg shadow">
//             {/* Filter Options */}
//             <div className="flex space-y-4 md:space-y-0 mb-6 space-x-4">
//               <div className="flex items-center">
//                 <label className="mr-2 font-semibold lg:text-sm text-xs ">
//                   Filter by:
//                 </label>
//                 <select
//                   name="dateRate"
//                   value={filters.dateRate}
//                   onChange={handleFilterChange}
//                   className="p-2 w-full md:w-44 lg:text-sm text-xs  rounded-md bg-headerBtn text-white focus:ring-1 focus:ring-headerBtn"
//                 >
//                   <option value="date">Date</option>
//                   <option value="rate">Rate</option>
//                 </select>
//               </div>

//               <div className="flex items-center ">
//                 <select
//                   name="sortOrder"
//                   value={filters.sortOrder}
//                   onChange={handleFilterChange}
//                   className="p-2 w-full md:w-44 lg:text-sm text-xs rounded-md bg-white text-headerBtn focus:ring-1 focus:ring-headerBtn lg:-mt-0 -mt-4"
//                 >
//                   <option value="ascending">Ascending</option>
//                   <option value="descending">Descending</option>
//                 </select>
//               </div>
//             </div>

//             {/* Display Filtered Data */}
//             <div className="overflow-x-auto ">
//               <table className="w-full text-center table-auto border-collapse">
//                 <thead>
//                   <tr className="bg-AboutUsBg lg:text-sm text-xs ">
//                     <th className="p-3">S/N</th>
//                     <th className="p-3">LC Applicant</th>
//                     <th className="p-3">Rate</th>
//                     <th className="p-3">Bank Name</th>
//                     <th className="p-3">Currency</th>
//                     <th className="p-3">Source Country</th>
//                     <th className="p-3">Required Time</th>
//                     <th className="p-3">Due Diligence</th>
//                     <th className="p-3">Contact Info</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredData.map((row, index) => (
//                     <tr key={row.id} className="lg:text-sm text-xs ">
//                       <td className="py-2 px-4">{index + 1}</td>
//                       <td className="p-3">{row.lc_applicant}</td>
//                       <td className="p-3">{row.rate}</td>
//                       <td className="p-3">{row.name_of_the_bank}</td>
//                       <td className="p-3">
//                         {row.currency} {row.currency_type}
//                       </td>
//                       <td className="p-3">{row.source_country}</td>
//                       <td className="p-3">{row.required_time}</td>
//                       <td className="p-3">{row.due_diligence}</td>
//                       <td>
//                         <button
//                           onClick={e => {
//                             e.stopPropagation();
//                             handleContactInfoView(row);
//                           }}
//                           className="text-white bg-green-600 hover:bg-headerBtn transition-colors px-2 py-1 rounded-md"
//                           aria-label="View"
//                         >
//                           View
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>

//               <ContactInfoView
//                 isOpen={isModalOpen}
//                 onClose={handleCloseModal}
//                 loanDetails={selectedLoan}
//               />
//             </div>
//           </div>
//         </div>
//       </td>
//     </tr>
//   );
// };

// export default ChildTable;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ContactInfoView from './ContactInfoView';
import { API_BASE_URL } from '../../../config';
const ChildTable = ({ loan_ID}) => {
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filters, setFilters] = useState({
    dateRate: '',
    sortOrder: '',
  });
  const [data, setData] = useState([]);

  const handleContactInfoView = loan => {
    setSelectedLoan(loan);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  console.log(loan_ID);
  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          // `https://finwise-backend.vercel.app/account/approved-loan-list/${loan_ID}/`,
          // `https://finwiseback.finwise.com.bd/account/approved-loan-list/${loan_ID}/`,
          // `http://127.0.0.1:8000/account/approved-loan-list/${loan_ID}/`,
          `${API_BASE_URL}/account/approved-loan-list/${loan_ID}/`,
          {
            headers: {
              Cookie: 'sessionid=vonpwnmq5904ndb7w395ect6tmgzey2r',
            },
          }
        );
        console.log('upas child table:', response.data);
        setData(response.data.loans); // Set the API data
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
    //  const intervalId = setInterval(() => {
    // fetchData(); // Fetch loans every 5 seconds
    //  }, 5000);

     // Cleanup the interval on component unmount
    //  return () => clearInterval(intervalId);
  }, [loan_ID]);



  // Handle the filter and sort
  const handleFilterChange = e => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  // Apply filters and sorting
  const filteredData = Array.isArray(data)
    ? data
        .sort((a, b) => {
          if (filters.sortOrder === 'ascending') {
            return parseFloat(a.rate) - parseFloat(b.rate);
          } else if (filters.sortOrder === 'descending') {
            return parseFloat(b.rate) - parseFloat(a.rate);
          }
          return 0;
        })
        .filter(item => {
          if (filters.dateRate === 'rate') {
            return parseFloat(item.rate) >= 0; // Adjust rate filter logic as needed
          } else if (filters.dateRate === 'date') {
            return item.created_at >= '2024-08-01'; // Adjust date filter logic as needed
          }
          return true;
        })
    : []; // If not an array, return an empty array

  return (
    <tr>
      <td colSpan="9">
        <div className="w-full p-4 bg-white">
          <div className="bg-AboutUsBg p-4 rounded-lg shadow">
            {/* Filter Options */}
            <div className="flex space-y-4 md:space-y-0 mb-6 space-x-4">
              <div className="flex items-center">
                <label className="mr-2 font-semibold lg:text-sm text-xs ">
                  Filter by:
                </label>
                <select
                  name="dateRate"
                  value={filters.dateRate}
                  onChange={handleFilterChange}
                  className="p-2 w-full md:w-44 lg:text-sm text-xs rounded-md bg-headerBtn text-white focus:ring-1 focus:ring-headerBtn"
                >
                  <option value="date">Date</option>
                  <option value="rate">Rate</option>
                </select>
              </div>
              <div className="flex items-center ">
                <select
                  name="sortOrder"
                  value={filters.sortOrder}
                  onChange={handleFilterChange}
                  className="p-2 w-full md:w-44 lg:text-sm text-xs rounded-md bg-white text-headerBtn focus:ring-1 focus:ring-headerBtn lg:-mt-0 -mt-4"
                >
                  <option value="ascending">Ascending</option>
                  <option value="descending">Descending</option>
                </select>
              </div>
            </div>
            {/* Display Filtered Data */}
            <div className="overflow-x-auto ">
              <table className="w-full text-center table-auto border-collapse">
                <thead>
                  <tr className="bg-AboutUsBg lg:text-sm text-xs ">
                    <th className="p-3">S/N</th>
                    <th className="p-3">LC Applicant</th>
                    <th className="p-3">Rate</th>
                    <th className="p-3">Bank Name</th>
                    <th className="p-3">Currency</th>
                    <th className="p-3">Source Country</th>
                    <th className="p-3">Required Time</th>
                    <th className="p-3">Due Diligence</th>
                    <th className="p-3">Status</th>
                    <th className="p-3">Contact Info</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((row, index) => (
                    <tr key={row.id} className="lg:text-sm text-xs ">
                      <td className="py-2 px-4">{index + 1}</td>
                      <td className="p-3">{row.lc_applicant}</td>
                      <td className="p-3">{row.rate}</td>
                      <td className="p-3">{row.name_of_the_bank}</td>
                      <td className="p-3">
                        {row.currency} {row.currency_type}
                      </td>
                      <td className="p-3">{row.source_country}</td>
                      <td className="p-3">{row.required_time}</td>
                      <td className="p-3">{row.due_diligence}</td>
                      <td className="py-2 px-4">
                        <button
                          className={`px-3 py-1 rounded-md md:w-28 w-20 ${
                            row.status === 'offered'
                              ? 'bg-green-500 text-white'
                              : row.status === 'pending'
                              ? 'bg-yellow-500 text-white'
                              : row.status === 'cancel'
                              ? 'bg-red-500 text-white'
                              : 'bg-gray-500 text-white'
                          }`}
                        >
                          {row.status === 'offered'
                            ? 'Offered'
                            : row.status === 'pending'
                            ? 'Pending'
                            : row.status === 'cancel'
                            ? 'Cancelled'
                            : 'Null'}
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={e => {
                            e.stopPropagation();
                            handleContactInfoView(row);
                          }}
                          className="text-white bg-green-600 hover:bg-headerBtn transition-colors px-2 py-1 rounded-md"
                          aria-label="View"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <ContactInfoView
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                loanDetails={selectedLoan}
              />
            </div>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default ChildTable;
